import * as React from "react"

import type { RemoteCursor } from "../api"

import type { PageGeometry } from "./pdf-surface"

export const CursorLayer = React.memo(function CursorLayer({
  geom,
  cursors,
  zoom = 1,
}: {
  geom: PageGeometry
  cursors: RemoteCursor[]
  /** The scale the page is drawn at; each cursor is counter-scaled to keep its size. */
  zoom?: number
}): JSX.Element | null {
  // Filter to current page once per cursor batch. Presence updates arrive
  // as often as reviewers move their mouse; running .filter() on every
  // parent re-render is unbounded churn.
  const onPage = React.useMemo(
    () => cursors.filter((c) => c.page === geom.page),
    [cursors, geom.page],
  )
  if (onPage.length === 0) return null
  const scaleX = geom.cssWidth / geom.pointWidth
  const scaleY = geom.cssHeight / geom.pointHeight
  return (
    <div className="pointer-events-none absolute inset-0" aria-hidden="true">
      {onPage.map((c) => (
        <div
          key={c.userId}
          className="absolute transition-[left,top] duration-100 ease-out"
          style={{
            left: c.x * scaleX,
            top: c.y * scaleY,
            scale: String(1 / zoom),
            transformOrigin: "top left",
          }}
        >
          <svg
            className="drop-shadow-[0_2px_4px_rgb(0_0_0/0.4)]"
            width={14}
            height={16}
            viewBox="0 0 14 16"
            fill="var(--brand)"
          >
            <path d="M0 0 L14 6 L6 8 L4 16 Z" />
          </svg>
          <span className="ml-2 inline-block rounded-sm bg-[color:var(--brand)] px-1.5 py-0.5 text-[10px] font-medium text-white shadow-sm">
            {c.role}
          </span>
        </div>
      ))}
    </div>
  )
})
